<template>
    <div style="width: 100%;height: 100%">
      <div style="height: 10px">
        <video v-if="myself"  style="width: 0px;height: 0px" ref="myvideo" id="my-video" muted autoplay></video>
        <video v-if="other" style="width: 0px;height: 0px" ref="peervideo" id="peer-video" autoplay></video>
        <audio v-if="showVoice" src="/static/phone/phone.mp3" muted autoplay="autoplay"  loop="loop"/>
      </div>
      <div style="height: 28px;">
        <div class="del-left">
          <img style="vertical-align: middle;cursor: pointer" src="../../../assets/sipicon/index_phone_cancel.png" @click="delMember()">
        </div>
        <div class="member-center">
          <input type="member" v-model="keyMember" class="member-inp"/>
        </div>
        <div class="del-right">
          <img style="vertical-align: middle;cursor: pointer" src="../../../assets/sipicon/index_phone_del.png" @click="cancelMember()">
        </div>
      </div>
      <div :class="callKeyboard ? 'keyboard-bottom' : 'keyboard-bottom-calling'">
        <div v-if="callKeyboard" style="margin: 0px 15px">
          <div style="height: 10px"></div>
          <el-row>
            <el-col :span="8">
              <div class="member-item" @click="addMember(1)">1</div>
            </el-col>
            <el-col :span="8">
              <div class="member-item" @click="addMember(2)">2</div>
            </el-col>
            <el-col :span="8">
              <div class="member-item" @click="addMember(3)">3</div>
            </el-col>
          </el-row>
          <el-row style="margin-top: 10px">
            <el-col :span="8">
              <div class="member-item" @click="addMember(4)">4</div>
            </el-col>
            <el-col :span="8">
              <div class="member-item" @click="addMember(5)">5</div>
            </el-col>
            <el-col :span="8">
              <div class="member-item" @click="addMember(6)">6</div>
            </el-col>
          </el-row>
          <el-row style="margin-top: 10px">
            <el-col :span="8">
              <div class="member-item" @click="addMember(7)">7</div>
            </el-col>
            <el-col :span="8">
              <div class="member-item" @click="addMember(8)">8</div>
            </el-col>
            <el-col :span="8">
              <div class="member-item" @click="addMember(9)">9</div>
            </el-col>
          </el-row>
          <el-row style="margin-top: 10px">
            <el-col :span="8">
              <div class="member-item">*</div>
            </el-col>
            <el-col :span="8">
              <div class="member-item" @click="addMember(0)">0</div>
            </el-col>
            <el-col :span="8">
              <div class="member-item">#</div>
            </el-col>
          </el-row>
        </div>
        <div v-else style="margin: 0px 15px">
          <div style="height: 35px"></div>
          <div style="height: 50px;text-align: center">
            <div style="height: 25px">
              <span>{{keyMember}}</span>
            </div>
            <div style="height: 30px;color: #999999">
              <span v-if="startTime === ''">正在呼叫中</span>
              <span v-else>{{startTime}}</span>
            </div>
          </div>
          <div style="height: 20px"></div>
        </div>
        <div style="margin-top: 5px">
          <div v-if="callPhoneSHow" class="call-btn" @click="keyboardCall(0, keyMember)">拨 打</div>
          <div v-else class="hang-up" @click="stopua()">挂 断</div>
        </div>
      </div>
    </div>
</template>

<script>
import * as JsSIP from 'jssip'
export default {
  name: 'sipKeyboard',
  data () {
    return {
      keyMember: '',
      callKeyboard: true,
      startTime: '',
      intervalTime: null,
      isShow: false,

      ua: {},
      password: 'test0063',
      reUserName: 'sip:sp-2663@rtc.ucserver.cc',
      userName: 'sp-2664@116.30.195.159:49388',
      session: '',
      callsession: '',
      myself: false,
      other: false,
      showVoice: false,
      hangUp: false,
      // answerShow: false,
      callAnswer: true,
      callPhoneSHow: true
    }
  },
  created () {
    this.golobleObject.sendCallPhone = this.callPhone
    this.golobleObject.sendEndPhone = this.stopua
    this.golobleObject.sendAcceptCall = this.answerPhone
  },
  mounted () {
    let sipinfo = this.$store.state.user.sipinfo
    if (sipinfo) {
      if (sipinfo.sip_type === 2) {
        this.init()
      }
    }
  },
  methods: {
    async init () {
      let socket = new JsSIP.WebSocketInterface('wss://webrtc.ucserver.cc:1443/wss')
      // JsSIP.debug.enable('JsSIP:*')
      const configuration = {
        display_name: 'ccc',
        uri: this.reUserName, // sip:sp-2664@rtc.ucserver.cc
        password: this.password, // 'test0064'
        outbound_proxy_set: 'wss://webrtc.ucserver.cc:1443/wss',
        sockets: [socket],
        registrar_server: null,
        contact_uri: this.reUserName,
        authorization_user: null,
        instance_id: null,
        session_timers: true,
        use_preloaded_route: false
      }
      const ua = new JsSIP.UA(configuration)
      await ua.register()
      await ua.start()
      this.ua = ua
      let vm = this
      this.ua.on('connected', function (e) { /* Your code here 连接 */
        // console.log(111, e)
      })
      this.ua.on('disconnected', function (e) { /* Your code here 断开 */
        // console.log(222, e)
      })
      this.ua.on('newMessage', function (e) { /* Your code here */
        // console.log(333, e)
      })
      this.ua.on('registered', function (e) {
        console.log('--------已注册-------')
      })
      this.ua.on('unregistered', function (e) {
        console.log('------未注册--------')
      })
      this.ua.on('registrationFailed', e => {
        this.$message.error('SIP注册失败,请联系管理员')
      })
      this.ua.on('newRTCSession', (e) => {
        console.log('newRTCSession', e.request.from.uri.user)
        vm.callsession = e.session
        // vm.answerShow = true  sp-2664
        let phone = e.request.from.uri.user.split('-')
        console.log(7890, phone[1])
        if (phone[1] !== '2663') {
          // 来电
          // vm.golobleObject.sendKeyboard(7)
          vm.golobleObject.sendCalling(phone[1], 1, 0)
        }
        vm.showVoice = true

        // 其中能拿到session对象和originator对象
        // originator代表通话时本地呼出还是远程呼入
        const { session } = e
        // 连接中
        session.on('connecting', () => {
          console.log('连接中')
          vm.callPhoneSHow = false
          // vm.answerShow = true
          vm.showVoice = true
          vm.hangUp = true
        })
        // 连接已接受
        session.on('accepted', () => {
          console.log('连接已接受')
          vm.showVoice = false
          vm.golobleObject.sendCallTime()
          vm.getTimeing()
          vm.hangUp = true
          vm.$refs['peervideo'].srcObject = e.session.connection.getRemoteStreams()[0]
          navigator.mediaDevices.getUserMedia({'audio': true, 'video': false}).then(stream => {
            e.session.connection.addStream(stream)
          })
        })
        // 接通,在这一步可以处理音频播放
        // 接通并不代表对方已经接受，接通代表 滴 滴 滴
        session.on('confirmed', (event) => {
          console.log('confirmed声音', event)
        })
        // 结束
        session.on('ended', () => {
          vm.callAnswer = true
          // vm.answerShow = false
          vm.golobleObject.sendCalling('', 0, 0)
          vm.golobleObject.sendKeyboard()
          vm.showVoice = false
          vm.hangUp = false
          vm.callPhoneSHow = true
          // this.$refs.meVideo[0].stop()
          console.log('结束')
          vm.myself = false
          vm.other = false
          vm.callsession = ''
          vm.isShow = false
          if (vm.intervalTime !== null) {
            clearInterval(this.intervalTime)
          }
          vm.intervalTime = null
          vm.callKeyboard = true
        })
        // 失败
        session.on('failed', () => {
          console.log('失败')
          vm.callsession = ''
          vm.callAnswer = true
          // vm.answerShow = false
          vm.showVoice = false
          vm.hangUp = false
          vm.callPhoneSHow = true
          vm.golobleObject.sendCalling('', 0, 0)
          vm.golobleObject.sendKeyboard()
          vm.isShow = false
          if (vm.intervalTime !== null) {
            clearInterval(this.intervalTime)
          }
          vm.intervalTime = null
          vm.callKeyboard = true
        })
      })
    },
    // 挂斷
    stopua () {
      this.ua.terminateSessions()
      this.callsession = ''
      this.myself = false
      this.other = false
      this.isShow = false
      if (this.intervalTime !== null) {
        clearInterval(this.intervalTime)
      }
      this.intervalTime = null
      this.callKeyboard = true
      // this.golobleObject.sendKeyboard(6)
    },
    // 呼叫
    keyboardCall (val, phone) {
      this.callKeyboard = false
      this.isShow = true
      this.callPhone(val, phone)
    },
    callPhone (val, phone) {
      if (val === 1) {
        // 客服关爱
        this.golobleObject.sendCalling(phone, 1, 1)
      }
      this.callAnswer = false
      this.myself = true
      this.other = true
      const eventHandlers = {
        'progress': function (e) {
          console.log('call is in progress', e)
        },
        'failed': function (e) {
          console.log('call failed with cause: ', e)
        },
        'ended': function (e) {
          console.log('call ended with cause: ', e)
        },
        'confirmed': function (e) {
          console.log('call confirmed', e)
        },
        'succeeded': function (e) {
          console.log('发送成功', e)
        }
      }
      let vm = this
      navigator.mediaDevices.getUserMedia({'audio': true, 'video': false}).then(stream => {
        // this.$refs.meVideo.srcObject = stream
        const options = {
          'eventHandlers': eventHandlers,
          'mediaConstraints': {'audio': true, 'video': false},
          mediaStream: stream,
          'selfView': vm.$refs['myvideo'],
          'remoteView': vm.$refs['peervideo']
        }
        // sip:sp-2664@rtc.ucserver.cc
        vm.$refs['myvideo'].srcObject = stream
        let sendphone = 'sp-' + phone + '@116.30.195.159:49388'
        vm.session = vm.ua.call(sendphone, options)
        vm.callPhoneSHow = false
      }).catch((e) => { console.log(e) })
    },
    // 接听
    answerPhone () {
      this.myself = true
      this.other = true
      this.callsession.answer({'mediaConstraints': {'audio': true, 'video': true}})
    },
    delMember () {
      this.keyMember = ''
    },
    cancelMember () {
      this.keyMember = this.keyMember.substr(0, this.keyMember.length - 1)
    },
    addMember (val) {
      this.keyMember = this.keyMember + val
    },
    getTimeing () {
      if (this.isShow) {
        let count = 0
        this.intervalTime = setInterval(() => {
          count++
          this.timeStarting(count)
        }, 1000)
      }
    },
    timeStarting (count) {
      let s = parseInt(count % 60)
      let m = parseInt((count / 60) % 60)
      let h = parseInt(count / 60 / 60)
      if (s < 10) {
        s = '0' + s
      }
      if (m < 10) {
        m = '0' + m
      }
      if (h < 10) {
        h = '0' + h
      }
      this.startTime = h + ':' + m + ':' + s
      // console.log(this.startTime)
    }
  }
}
</script>

<style scoped>
  .del-left{
    float: left;
    height: 28px;
    width: 36px;
    text-align: center;
    line-height: 28px;
    background-image: linear-gradient(0deg,
    #00cc22 0%,
    #00d091 6%,
    #00d4ff 100%);
    border-radius: 8px 0px 0px 8px;
  }
  .member-center{
    width: 108px;
    height: 28px;
    float: left;
    background-color: white;
  }
  .member-inp{
    width: 108px;
    height: 28px;
    line-height: 28px;
    border: none;
    outline: none;
  }
  .del-right{
    float: left;
    height: 28px;
    width: 36px;
    text-align: center;
    line-height: 28px;
    background-image: linear-gradient(0deg,
    #00cc22 0%,
    #00d091 6%,
    #00d4ff 100%);
    border-radius: 0px 8px 8px 0px;
  }
  .keyboard-bottom{
    margin-top: 2px;
    width: 180px;
    height: 246px;
    background-color: #ebebeb;
    border-radius: 8px;
  }
  .keyboard-bottom-calling{
    margin-top: 2px;
    width: 180px;
    height: 166px;
    background-color: #ebebeb;
    border-radius: 8px;
  }
  .member-item{
    cursor: pointer;
    width: 40px;
    height: 40px;
    line-height: 40px;
    text-align: center;
    border-radius: 20px;
    color: black;
    font-size: 18px;
    background-color: #f2f2f2;
    border: solid 1px #d9d9d9;
  }
  .member-item:hover{
    background-color: #ffffff;
  }
  .call-btn{
    cursor: pointer;
    width: 140px;
    height: 26px;
    line-height: 26px;
    color: white;
    text-align: center;
    margin: auto;
    background-image: linear-gradient(0deg,
    #00cc22 0%,
    #00d091 10%,
    #00d4ff 100%);
    border-radius: 13px;
  }
  .hang-up{
    cursor: pointer;
    width: 140px;
    height: 26px;
    line-height: 26px;
    color: white;
    text-align: center;
    margin: auto;
    background-image: linear-gradient(0deg,
    #ff0000 0%,
    #bf0000 100%);
    border-radius: 13px;
  }
</style>



// WEBPACK FOOTER //
// src/components/navbar/childNavBar/sipKeyboard.vue